<template>

  <v-card elevation="0" class="annotation mb-4">
    <v-card-title class="text-subtitle-1 mb-2 pb-2" style="border-bottom: 1px solid #efefef">
      <div class="d-flex align-center">
        <v-img max-width="80px" height="80px" class="rounded-circle mr-3" v-if="annotation.user_created.avatar"
          :src="`https://api.mylegis.com.br/assets/${annotation.user_created.avatar.id}`" />
        <v-img max-width="40px" height="40px" class="rounded-circle mr-3" v-if="!annotation.user_created.avatar" contain
          src="../assets/icon-person.svg" />
        <div class="user-info">
          <div class="user-name">
            <router-link style="font-weight: 600;" :to="`/painel/u/${slugName(annotation.user_created)}`" class="mr-2">
              {{
                annotation.user_created.first_name
              }}

              {{ annotation.user_created.last_name !== null ? annotation.user_created.last_name : "" }}
            </router-link>
          </div>
          <div class="law-reference">
            <span class="text-caption">em</span>
            <router-link class="ml-2 law-link"
              :to="'/painel/lei/' + annotation.id_lei.id_lei + '/' + sanitizeTitle(annotation.id_lei.numero_lei)">
              {{ annotation.id_lei.numero_lei }}
            </router-link>
          </div>
        </div>
      </div>
    </v-card-title>

    <v-card-text class="annotationText pa-4">
      <div class="mb-3">
        <strong>Parágrafo da lei:</strong>
        <div class="reg mx-0 mt-2" v-html="annotation.id_reg.conteudo"></div>
      </div>

      <div class="mb-3">
        <div class="mb-2" v-html="annotation.texto"></div>
      </div>
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-end justify-end pa-3 pa-md-4" style="border-top: 1px solid #efefef">
      <div class="d-flex flex-column flex-md-row align-start align-md-center mb-3 w-100">
        <div class="d-flex flex-wrap mb-2 mb-md-0">
          <v-btn text class="mr-2 mr-md-4 mb-1 mb-md-0" small
            @click="annotation.likes.some(l => l.id === user.id) ? unlikeAnnotation() : likeAnnotation()">
            <v-icon class="mr-1 mr-md-2" color="#F15A24" size="16">mdi-thumb-up</v-icon>
            <span class="d-none d-sm-inline"> {{ annotation.likes.length }}
              {{annotation.likes.some(l => l.id === user.id) ? "Descurtir" : `Curtir`}}</span>
          </v-btn>
          <v-btn text class="mr-2 mr-md-4 mb-1 mb-md-0" small @click="showComments = !showComments">
            <v-icon class="mr-1 mr-md-2" color="#F15A24" size="16">mdi-comment</v-icon>
            <span class="d-none d-sm-inline">{{ annotation.comentarios ? annotation.comentarios.length : 0 }}
              Comentários</span>
          </v-btn>
          <v-btn :disabled="user.plano === `plano-free` || user.plano == ``" text
            @click="importPost = { ...annotation }; showNewAnnotation = true">
            <v-icon class="mr-1 mr-md-2" color="#F15A24" size="16">mdi-share</v-icon>
            <span class="d-none d-sm-inline">Importar post</span>
          </v-btn>
        </div>
      </div>

      <div class="d-flex flex-column flex-md-row align-start align-md-center justify-space-between w-100">
        <div style="gap: 10px;" class="d-flex  flex-md-row align-start align-md-center">
          <div class="d-flex align-center mb-1 mb-md-0" v-if="annotation.status === `group`">
            <v-icon small class="mr-1" color="grey">mdi-earth</v-icon>
            <span class="text-caption grey--text">{{ annotation.id_grupo.nome_grupo }}</span>
          </div>

          <div class="d-flex align-center mb-1 mb-md-0" v-else>
            <v-icon small class="mr-1" color="grey">{{
              annotation.status === `private`
                ? `mdi-lock`
                : `mdi-earth`
            }}</v-icon>
            {{ annotation.status | filterStatus }}
          </div>

          <div class="d-flex align-center ml-md-3">
            <v-icon small class="mr-1" color="grey">mdi-clock-outline</v-icon>
            <span class="text-caption grey--text">
              Criado em {{ annotation.date_updated === null ? annotation.date_created : annotation.date_updated
                | brdatetime }}
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column flex-md-row align-start align-md-center justify-space-between w-100 mt-4">
        <div class="d-flex justify-center justify-md-start mb-3 mb-md-0 mr-5">
          <!-- <v-img max-width="50" height="50" class="rounded-circle mr-3" v-if="annotation.user_created.avatar"
          :src="annotation.user_created && annotation.user_created.avatar ? `https://api.mylegis.com.br/assets/${annotation.user_created.avatar.id}` : require('../assets/icon-person.svg')"/>
          <v-img max-width="50" height="50" class="rounded-circle mr-3" v-if="!annotation.user_created.avatar" contain
            src="../assets/icon-person.svg" /> -->

          <!-- <v-img width="50" height="50" class="rounded-circle mr-3" :src="loggedAvatarSrc" style="background-size: contain;" /> -->
          <v-img max-width="60px" height="60px" class="rounded-circle "
            :src="user.avatar !== null ? `https://api.mylegis.com.br/assets/${user.avatar}` : require(`../assets/icon-person.svg`)" />
        </div>

        <div class="flex-grow-1 w-100 d-flex align-center">
          <v-text-field v-model="comment" append-icon="mdi-send" @click:append="postComment" variant="underlined"
            placeholder="Deixe seu comentário aqui" outlined dense hide-details color="#F15A24" background-color="white"
            class="mr-2"></v-text-field>
          <v-file-input style="width:100px" prepend-icon="mdi-paperclip" hide-input v-model="file"
            @change="handleFileAdded(file)" class="ml-2 pt-0"></v-file-input>
        </div>
      </div>

      <!-- Seção de anexos -->
      <div v-if="commentFiles.length > 0" class="mt-3 mb-3">
        <v-card flat class="pa-3" style="background-color: #f5f5f5; border-radius: 8px;">
          <div class="d-flex align-center mb-2">
            <v-icon color="#F15A24" class="mr-2">mdi-paperclip</v-icon>
            <span class="font-weight-bold">Anexos</span>
          </div>
          <div class="d-flex flex-wrap">
            <v-chip v-for="(f, index) in commentFiles" :key="f.id" class="ma-1" close
              @click:close="commentFiles.splice(index, 1)" color="#F15A24" text-color="white">
              <v-icon left small>mdi-file</v-icon>
              {{ f.filename_download }}
            </v-chip>
          </div>
        </v-card>
      </div>

      <!-- Seção de comentários - ocupando toda a largura -->
      <div class="mt-4 w-100">
        <v-divider class="mb-4"></v-divider>

        <!-- Mensagem quando não há comentários -->
        <div v-if="!annotation.comentarios || annotation.comentarios.length === 0" class="text-center pa-4">
          <v-icon color="grey" size="48" class="mb-2">mdi-comment-outline</v-icon>
          <p class="grey--text">
            Seja o primeiro a comentar neste post, digite sua mensagem no campo acima e pressione o botão!
          </p>
        </div>

        <!-- Lista de comentários -->
        <div v-else class="w-100">
          <v-list class="pa-0 w-100">
            <v-list-item v-for="(item, i) in annotation.comentarios" :key="i" class="px-0 mb-3 w-100"
              style="border: 1px solid #e0e0e0; border-radius: 8px; background-color: #fafafa;">
              <v-list-item-avatar class="mr-3">
                <v-avatar color="grey" size="40">
                  <v-img contain :src="item.user_created.avatar && item.user_created.avatar.id
                    ? `https://api.mylegis.com.br/assets/${item.user_created.avatar.id}`
                    : `https://api.mylegis.com.br/assets/${item.user_created.avatar}`" />
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="py-2 flex-grow-1">
                <v-list-item-title class="font-weight-bold text-subtitle-2">
                  {{ item.user_created.first_name }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-2 mt-1">
                  {{ item.message }}
                </v-list-item-subtitle>

                <!-- Anexos do comentário -->
                <div v-if="item.files && item.files.length > 0" class="mt-2">
                  <v-chip v-for="f in item.files" :key="f.id" small class="ma-1" color="primary" text-color="white"
                    @click="window.open(`https://api.mylegis.com.br/assets/${f.directus_files_id.id}?download`, '_blank')">
                    <v-icon left small>mdi-download</v-icon>
                    {{ f.directus_files_id.filename_download }}
                  </v-chip>
                </div>
              </v-list-item-content>

              <v-list-item-action v-if="item.user_created.id == user.id" class="ml-2">
                <v-btn color="grey" icon small @click="deleteComment(item.id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-card-actions>

    <v-dialog width="85vw" v-model="showNewAnnotation">
      <v-card class="px-5">
        <v-card-title class="px-0">Importar Anotação <v-spacer />
          <v-btn @click="showNewAnnotation = false" text><v-icon large>mdi-close</v-icon></v-btn></v-card-title>
        <v-card-text>
          <h3></h3>
          <p class="pa-2" style="border: 1px dashed #f15a24">{{ importPost.id_lei.numero_lei }}</p>
          <p class=" mx-0 "> {{ importPost.id_reg.conteudo }} </p>
          <h3>Vade-mécum</h3>
          <v-select color="#F15A24" :items="vadeMecuns" v-model="importPost.id_vademecum" item-text="titulo"
            item-value="id">
            <!-- <template v-slot:prepend-item="[item]">
							{{ item.id }}
						</template> -->
          </v-select>
          <h3>Visibilidade</h3>
          <v-select color="#F15A24" :items="statusAnnotation" v-model="importPost.status"></v-select>
          <h3 v-if="importPost.status == `group`">Selecione o grupo</h3>
          <v-select v-if="importPost.status == `group`" item-text="grupos_id.nome_grupo" item-value="grupos_id.id"
            color="#F15A24" :items="groups" v-model="importPost.id_grupo"></v-select>
          <h3 class="d-flex">
            Conteúdo
          </h3>
          <VueEditor use-custom-image-handler @image-added="handleImageAdded" ref="editor" color="#F15A24"
            :editor-toolbar="customToolbar" v-model="importPost.texto" />
        </v-card-text>
        <v-card-actions class="justify-end px-0">
          <v-btn text @click="showNewAnnotation = false">Cancelar</v-btn>
          <v-btn :loading="loadingNewAnnotation" dark @click="saveNewAnnotation()" color="#F15A24">Salvar
            <v-icon class="ml-1" small>mdi-content-save</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>


</template>

<style scoped>
h5 {
  color: #F15A24 !important;
}

.annotation {
  border: 1px solid rgb(200 200 200) !important;
  margin: 8px 0px;
  border-radius: 10px;
}

.annotationText div {
  width: 100%;
}

.secondRow h3 {
  margin: 30px 0px 0px 15px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}

.reg {
  background-color: #efefef;
  border-radius: 10px;
  padding: 15px;
}

.annotation ::v-deep a {
  color: black !important;
  text-decoration: underline;
  padding: 0
}

a:hover,
.annotation ::v-deep a:hover {
  text-decoration: underline;
  color: #F15A24 !important;

}
</style>

<script>
import axios from 'axios'
import { VueEditor } from "vue2-editor";
export default {
  name: "Annotation",
  components: { VueEditor },
  props: ["annotation"],
  data() {
    return {
      me: null,
      comment: "",
      commentFiles: [],
      file: null,
      showComments: false,
      importPost: { id_lei: {}, id_reg: {} },
      loadingNewAnnotation: false,
      showNewAnnotation: false,
      statusAnnotation: [
        { text: "Público", value: "published" },
        { text: "Grupo", value: "group" },
        { text: "Privado", value: "private" },
        { text: "Apenas Amigos", value: "friend" },
        { text: "Arquivado", value: "archived" },
      ],
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [
          { header: "1" },
          { header: "2" },
          "blockquote",
          "code-block",
        ],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
    }
  },
  computed: {
    loggedAvatarSrc() {
      const fileId =
        this.me && this.me.avatar ? (this.me.avatar.id || this.me.avatar) : null
      return fileId
        ? `https://api.mylegis.com.br/assets/${fileId}`
        : require('../assets/icon-person.svg')
    },
    groups() {
      return this.$store.state.user.grupos
    },
    user() {
      return this.$store.state.user;
    },
    vadeMecuns() {
      return this.$store.state.vadeMecuns
    },

  },
  methods: {
    async mounted() {
      // REST do Directus
      const { data } = await axios.get(
        'https://api.mylegis.com.br/users/me?fields=id,first_name,last_name,avatar.id',
        { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } }
      )
      this.me = data.data
    },

    async reloadComments() {
      try {
        // window.console.log("vai")
        let rdm = Math.random()
        let fields = "id,message,user_created.id,user_created.first_name,user_created.avatar,files.directus_files_id.*"
        let { data } = await this.$http(`/items/comentarios?sort=-date_created&fields=${fields}&filter[status][_eq]=published&filter[annotation][_eq]=${this.annotation.id}&rdm=${rdm}`);
        // window.console.log(data)
        this.annotation.comentarios = data.data
      } catch (e) { window.console.log(e) }
    },
    async postComment() {
      try {
        if (this.comment.length > 1000) return
        // console.log(route.params)
        // const filter = { status:"published", asset: photo.value.id};
        const files = this.commentFiles.map(e => ({ directus_files_id: { id: e.id } }))

        this.commentFiles.map(e => e.id)
        const { data } = await this.$http.post("/items/comentarios", {
          annotation: this.annotation.id,
          status: "published",
          message: this.comment,
          files: { create: files }
        });

        // selective.value = items[0]
        // window.console.log(data)

        if (data.data.id) {
          this.comment = ""
          this.commentFiles = []
          this.reloadComments()
        }
      }
      catch (e) {
        window.console.log(e)
      }
    },
    async deleteComment(id) {
      await this.$http.patch("/items/comentarios/" + id, { status: "draft" })
      // window.console.log(data)
      this.reloadComments()
    },
    async likeAnnotation() {
      const likes = { update: [{ id: this.user.id, curtidas: this.annotation.id }] }
      const { data } = await this.$http.patch("/items/anotacoes/" + this.annotation.id, { likes })
      // window.console.log(data.data.likes)
      this.annotation.likes = data.data.likes
    },
    async unlikeAnnotation() {
      let idCurtida = null
      this.annotation.likes.find((l, i) => {
        if (l.id === this.user.id) {
          idCurtida = l.id
          this.annotation.likes.splice(i, 1)
        }
      })
      const likes = { delete: [idCurtida] }

      const { data } = await this.$http.patch("/items/anotacoes/" + this.annotation.id, { likes })
      window.console.log(data.data.likes)
      this.annotation.likes = data.data.likes
    },
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
    slugName(user) {
      return user.id + "/" + this.sanitizeTitle(user.first_name)
    },
    handleImageAdded(file, Editor, cursorLocation) {
      // window.console.log(file);
      const formData = new FormData();
      formData.append("file", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // window.console.log(response);
          let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
          Editor.insertEmbed(cursorLocation, "image", url);
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    handleFileAdded(file) {
      // window.console.log(file);
      const formData = new FormData();
      formData.append("file", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let file = response.data.data
          //window.console.log(file)
          this.commentFiles.push(file)
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // saveNewAnnotation() {
    //   this.loadingNewAnnotation = true;
    //   let dt = {
    //     id_lei: this.importPost.id_lei,
    //     id_reg: this.importPost.id_reg,
    //     status: this.importPost.status,
    //     id_grupo: this.importPost.status == `group` ? this.importPost.id_grupo : null,
    //     texto: this.importPost.texto,
    //     id_vademecum: this.importPost.id_vademecum
    //   };
    //   this.$http
    //     .post("items/anotacoes", dt)
    //     .then((response) => {
    //       if (response.data.data.id != undefined) {
    //         this.loadingNewAnnotation = false;
    //         this.showNewAnnotation = false;
    //         // this.importPost = { status: "private" };
    //         this.importPost = { id_lei: {}, id_reg: {} },
    //           this.conteudoSelected = {};


    //         let conteudo = this.conteudos.find(
    //           (el) => el.id_reg === dt.id_reg
    //         );
    //         if (conteudo.anotacoes)
    //           conteudo.anotacoes.push(response.data.data);
    //         else conteudo.anotacoes = [response.data.data];
    //       }
    //     })
    //     .catch(() => {
    //       this.loadingNewAnnotation = false;
    //     });
    // },

    saveNewAnnotation() {
      this.loadingNewAnnotation = true;

      this.verificarEAdicionarLeiNoVadeMecum()
        .then(() => {
          let dt = {
            id_lei: this.importPost.id_lei,
            id_reg: this.importPost.id_reg,
            status: this.importPost.status,
            id_grupo: this.importPost.status == `group` ? this.importPost.id_grupo : null,
            texto: this.importPost.texto,
            id_vademecum: this.importPost.id_vademecum
          };

          return this.$http.post("items/anotacoes", dt);
        })
        .then((response) => {
          if (response.data.data.id != undefined) {
            this.loadingNewAnnotation = false;
            this.showNewAnnotation = false;
            this.importPost = { id_lei: {}, id_reg: {} };
            this.conteudoSelected = {};

            let conteudo = this.conteudos.find((el) => el.id_reg === this.importPost.id_reg);
            if (conteudo.anotacoes)
              conteudo.anotacoes.push(response.data.data);
            else conteudo.anotacoes = [response.data.data];
          }
        })
        .catch((error) => {
          window.console.error('Erro:', error);
          this.loadingNewAnnotation = false;
        });
    },

    verificarEAdicionarLeiNoVadeMecum() {
      return new Promise((resolve) => {
        // Substituir o optional chaining por verificações tradicionais
        let leiId;
        if (this.importPost.id_lei && typeof this.importPost.id_lei === 'object') {
          leiId = this.importPost.id_lei.id_lei;
        } else {
          leiId = this.importPost.id_lei;
        }

        const vadeMecumId = this.importPost.id_vademecum;

        if (!leiId || !vadeMecumId) {
          window.console.warn('ID da lei ou vade-mécum não encontrado');
          resolve();
          return;
        }

        this.$http.get(`items/vademecums/${vadeMecumId}?fields=*,leis.leis_id_lei.id_lei`)
          .then(response => {
            const vadeMecum = response.data.data;

            // Verificar se a lei já existe no vade-mécum
            let leiExiste = false;
            if (vadeMecum.leis && Array.isArray(vadeMecum.leis)) {
              leiExiste = vadeMecum.leis.some(item => {
                return item.leis_id_lei && item.leis_id_lei.id_lei === leiId;
              });
            }

            if (!leiExiste) {
              window.console.log('Lei não encontrada no vade-mécum, adicionando...');
              return this.$http.patch(`items/vademecums/${vadeMecumId}`, {
                leis: {
                  create: [{
                    leis_id_lei: { id_lei: leiId },
                    vademecums_id: vadeMecumId,
                  }]
                }
              });
            } else {
              window.console.log('Lei já existe no vade-mécum');
              return Promise.resolve();
            }
          })
          .then(() => {
            window.console.log('Verificação concluída com sucesso');
            resolve();
          })
          .catch((error) => {
            window.console.error('Erro ao verificar vade-mécum:', error);
            resolve(); // Continua mesmo com erro
          });
      });
    }
  }
}
</script>